/**
 * 增值功能前端总开关（与后台 feature 接口无关）
 * 设为 false：不加载 SDK、不请求开关接口、不走对应业务流程
 * 恢复时改回 true 即可
 */
export const featureFlags = {
  /** 弹窗广告（首页场内付、支付页通道付） */
  popupAd: true,
  /** PP云特惠券包（banner + 支付拦截） */
  pyunCouponAd: true,
  /** 花瓣欠费追缴 */
  huabanEscape: true
}
